import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Toolbar, AppBar, Box } from '@material-ui/core';
import { useFooterStyles } from './styles';
import { useLocation } from 'react-router-dom';
import { HOME_ROUTE } from '../../../constants/routes';
import BackButton from '../../common/BackButton/';

const Footer = ({ ...props }) => {
  const { mobile } = props;
  const classes = useFooterStyles({ mobile });
  const { container, text, toolbar, appbar } = classes;
  const location = useLocation();

  return (
    <Box className={container}>
      <AppBar className={appbar}>
        {mobile && location.pathname !== HOME_ROUTE && <BackButton />}
        <Toolbar className={toolbar}>
          <Typography className={text}>
            <strong>
              Seguridad y Privacidad Garantizada SSL Secure GlobalSign. Comprar
              en Ripley.com es 100% seguro.
            </strong>
          </Typography>
          <Typography className={classes.text}>
            {' '}
            Comercial ECCSA S.A., Rut N° 83.382.700-6, domiciliada en Avenida
            Cerro Colorado 5240, Torre del Parque 1 Piso 11, comuna Las Condes,
            Santiago de Chile. Precios publicados aplican exclusivamente a
            Internet y Venta Telefónica, estos pueden llegar a ser distintos en
            tiendas.
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

Footer.propTypes = {
  mobile: PropTypes.bool,
};

export default Footer;
